// Day separator row in the calendar grid.

interface DayHeaderProps {
  day: string;
}

export function DayHeader({ day }: DayHeaderProps) {
  return <div className="calendar-day-header">{day}</div>;
}

export default DayHeader;
